import { IComponentOptions } from "angular";
import { GtmhubController } from "@gtmhub/core";
import { IParentOkrSelectorSearchResult, IParentOkrSelectorSuggestion } from "@webapp/okrs/models/parent-selector.models";
import { IParentOkrSelectorSuggestionSession } from "../models";

export class SuggestionTreeCtrl extends GtmhubController {
  // Bindings
  public source: IParentOkrSelectorSuggestionSession[];
  public selected: IParentOkrSelectorSearchResult[];
  public avatarPreviewNumber: number;
  public onSelected?: () => void;

  public select(row: IParentOkrSelectorSuggestion) {
    this.selected = [row];

    if (this.onSelected) {
      this.onSelected();
    }
  }

  public toggleRow(row: IParentOkrSelectorSuggestion) {
    if (!row.subItems?.length) {
      return;
    }

    row.expanded = !row.expanded;
  }
}

export const SuggestionTreeComponent: IComponentOptions = {
  controller: SuggestionTreeCtrl,
  template: require("./suggestion-tree.html"),
  bindings: {
    source: "<",
    selected: "=",
    avatarPreviewNumber: "<",
    onSelected: "&",
  },
};
